import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { ModalBody, ModalFooter } from 'reactstrap'
import CustomModal from '../CustomModal'
import CancelModalButton from 'components/Custom/CancelModalButton'
import DeleteButton from 'components/Custom/DeleteButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'

function ManageSubtitle(props) {
  useEffect(() => {
    props.fetchTextContent(props.match.params.id)
  }, [])

  const subtitle = props.content.find((item) =>
    item.id === parseInt(props.match.params.id) ? item : null
  )
  let language = props.language || {}

  return (
    <CustomModal courseId={props.course_id} title='Edit Subtitle' size='sm'>
      <ModalBody>
        <div className='row'>
          <div className='col-md-6 title-container'>
            <div className='upload-video-form-row'>
              <label>{'Subtitle'}: </label>
              <input
                type='text'
                name='title'
                autoFocus
                value={props.title ? props.title : ''}
                onChange={(event) =>
                  props.onChangeTitleText(event.target.value)
                }
              />
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className='d-flex justify-content-start mt-3'>
        <Link to={`/course/${props.id}/edit`}>
          <SubmitModalButton
            text={language.general ? language.general.submit : null}
            customFn={() => props.saveSubtitleContent(subtitle.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <DeleteButton
            text={language.general ? language.general.delete : null}
            customFn={() => props.deleteContent(subtitle.id)}
          />
        </Link>
        <Link to={`/course/${props.id}/edit`}>
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
          />
        </Link>
      </ModalFooter>
    </CustomModal>
  )
}

export default ManageSubtitle
